var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "product-card",
    class: 'product-card--' + _vm.num,
    attrs: {
      "flat": "",
      "color": "transparent",
      "href": _vm.href
    }
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('v-img', {
    staticClass: "product-card__bg",
    attrs: {
      "src": '/images/main/product-bg-' + _vm.num + '.png'
    }
  }), _c('v-img', {
    staticClass: "product-card__img",
    attrs: {
      "eager": "",
      "src": '/images/main/product-' + _vm.num + '.png'
    }
  })], 1), _c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm text-center"
  }, [_c('u-tit-default', {
    staticClass: "tit--sm"
  }, [_vm._v(_vm._s(_vm.$t(_vm.name)))])], 1), _c('txt-primary', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "product-card__tag"
  }, [_vm._v(_vm._s(_vm.$t(_vm.tag)))]), _c('p', [_vm._t("txt")], 2)]), _c('div', {
    staticClass: "btn-wrap btn-wrap--sm d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "product-card__btn",
    attrs: {
      "icon": "",
      "outlined": "",
      "color": "primary"
    }
  }, [_c('icon-arrow-secondary', {
    attrs: {
      "direction": "right",
      "size": "small"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }